var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgApprovedLock = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_178_21723)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 12.0002V14.0002H3V8.00021H7V7.00021H5V4.00021C5.00006 3.54067 5.15834 3.09517 5.44823 2.73859C5.73811 2.38202 6.14192 2.13613 6.59177 2.04226C7.04162 1.94839 7.51008 2.01226 7.91837 2.22314C8.32667 2.43402 8.64991 2.77905 8.83375 3.20021L9.75025 2.80021C9.47443 2.16859 8.98958 1.65119 8.37719 1.33496C7.7648 1.01874 7.06222 0.922972 6.38754 1.06377C5.71286 1.20457 5.10722 1.57334 4.67242 2.1081C4.23762 2.64286 4.00018 3.311 4 4.00021V7.00021H3C2.73488 7.00052 2.4807 7.10597 2.29323 7.29344C2.10576 7.48091 2.0003 7.73509 2 8.00021V14.0002C2.0003 14.2653 2.10576 14.5195 2.29323 14.707C2.4807 14.8945 2.73488 14.9999 3 15.0002H11C11.2651 14.9999 11.5193 14.8945 11.7068 14.707C11.8942 14.5195 11.9997 14.2653 12 14.0002V12.0002H11Z",
    fill: "#24A148"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 12.001L5 9.59988L5.7065 8.92147L7.5 10.6432L11.2925 7.00098L12 7.68035L7.5 12.001Z",
    fill: "#24A148"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_178_21723"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgApprovedLock);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/approved_lock.73a5e623c20424e61fbe0884484e0b7e.svg";